/* eslint-disable no-param-reassign */
window.TV2 = window.TV2 || {};

window.TV2.countdown = (
  contentbox,
  countdownDate,
  showPoster,
  countdownDaysBefore,
  displayDetailedCountdown,
) => {
  const root = document.getElementById(contentbox);

  const daysBefore = countdownDaysBefore ? parseInt(countdownDaysBefore, 10) : 1;

  if (!root || !countdownDate || countdownDate === 'Invalid Date') {
    return;
  }

  const dayBox = root.querySelector('.countdown__day');
  const hourBox = root.querySelector('.countdown__hour');
  const minuteBox = root.querySelector('.countdown__minute');
  const secondBox = root.querySelector('.countdown__second');
  const dayNumberBox = root.querySelector('.countdown__day .countdown__number .countdown__digits');
  const dayLabelBox = root.querySelector(
    '.countdown__day .countdown__label .countdown__label-text',
  );
  const hourLabelBox = root.querySelector(
    '.countdown__hour .countdown__label .countdown__label-text',
  );
  const hourNumberBox = root.querySelector(
    '.countdown__hour .countdown__number .countdown__digits',
  );
  const minuteNumberBox = root.querySelector(
    '.countdown__minute .countdown__number .countdown__digits',
  );
  const secondNumberBox = root.querySelector(
    '.countdown__second .countdown__number .countdown__digits',
  );

  const drawTimeValue = (
    type,
    number,
    padNumber,
    singleLabel,
    pluralLabel,
    numberElement,
    labelElement,
  ) => {
    if (labelElement) {
      if (number === 1) {
        labelElement.innerHTML = singleLabel;
      } else {
        labelElement.innerHTML = pluralLabel;
      }
    }

    if (!numberElement) return;

    if (numberElement.nextElementSibling) {
      if (number < 10) {
        if (padNumber) {
          number = `0${number}`;
          numberElement.nextElementSibling.innerHTML = '00';
        } else {
          numberElement.nextElementSibling.innerHTML = '0';
        }
      } else {
        if (type === 'days' && number > 100) {
          numberElement.nextElementSibling.innerHTML = '000';
        } else {
          numberElement.nextElementSibling.innerHTML = '00';
        }
      }
    }

    // eslint-disable-next-line no-param-reassign
    numberElement.innerHTML = number;
  };

  const isPastTimeOfDay = (now, toDate) => {
    const currentHour = now.getHours();
    const countdownHour = toDate.getHours();
    if (currentHour < countdownHour) {
      return false;
    }
    if (currentHour === countdownHour) {
      return now.getMinutes() >= toDate.getMinutes();
    }

    return true;
  };

  const updateTimeValues = () => {
    const now = new Date();
    const toDate = new Date(countdownDate);
    const totalSeconds = Math.floor((toDate.getTime() - now.getTime()) / 1000);
    const accurateDays = totalSeconds / 24 / 60 / 60;
    const accurateHours = totalSeconds / 60 / 60;

    const days = Math.floor(accurateDays);
    const displayDays = isPastTimeOfDay(now, toDate)
      ? Math.ceil(accurateDays)
      : Math.floor(accurateDays);
    const hoursLeft = Math.floor(totalSeconds - days * 86400);
    const hours = Math.floor(hoursLeft / 3600);
    const displayHours = Math.floor(accurateHours);
    const minutesLeft = Math.floor(hoursLeft - hours * 3600);
    const minutes = Math.floor(minutesLeft / 60);
    const seconds = Math.round(totalSeconds % 60);

    if (totalSeconds <= 0) {
      if (showPoster) {
        root.querySelector('.countdown__poster').classList.add('countdown__poster--show');
        root.querySelector('.countdown__counter').classList.add('countdown__counter--hide');
      }
      // eslint-disable-next-line no-use-before-define
      clearInterval(updateInterval);
      drawTimeValue('', 0, false, null, null, secondNumberBox, null);
      return;
    }

    drawTimeValue(
      'days',
      displayDays,
      false,
      'dag igjen',
      'dager igjen',
      dayNumberBox,
      dayLabelBox,
    );
    drawTimeValue('hours', displayHours, false, null, null, hourNumberBox, null);
    drawTimeValue('minutes', minutes, true, null, null, minuteNumberBox, null);
    drawTimeValue('seconds', seconds, true, null, null, secondNumberBox, null);

    if (daysBefore < accurateDays) {
      dayBox.classList.add('countdown__count--show');
      hourBox.classList.remove('countdown__count--show');
      minuteBox.classList.remove('countdown__count--show');
      secondBox.classList.remove('countdown__count--show');
    } else if (displayHours > 1 && daysBefore > accurateDays && !displayDetailedCountdown) {
      drawTimeValue(
        'hours',
        displayHours,
        false,
        'time igjen',
        'timer igjen',
        hourNumberBox,
        hourLabelBox,
      );
      dayBox.classList.remove('countdown__count--show');
      hourBox.classList.add('countdown__count--show', 'countdown__label--show');
      minuteBox.classList.remove('countdown__count--show');
      secondBox.classList.remove('countdown__count--show');
    } else {
      dayBox.classList.remove('countdown__count--show');
      hourBox.classList.add('countdown__count--show');
      hourBox.classList.remove('countdown__label--show');
      minuteBox.classList.add('countdown__count--show');
      secondBox.classList.add('countdown__count--show');
    }
  };

  updateTimeValues();
  const updateInterval = setInterval(updateTimeValues, 1000);
};
